import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getInvoices = async () => {
  const data = await axios.get(`${api_base_url}/VendorInvoice`);
  return data;
};

export const getInvoiceForEdit = async (recordNumber) => {
  return await axios.get(`${api_base_url}/VendorInvoice`).then((res) => {
    return res.data;
  });
};

export const getInvoiceById = async (id) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/GetVendorInvoiceById`,
    id
  );
};
export const geVoidedInvoiceById = async (id) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/GetVoidedInvoiceById`,
    id
  );
};

export const getOfficeVendors = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetOfficeVendors`
  );
  return data;
};

export const addInvoice = async (addVendorInvoiceData) => {
  const formData = new FormData();
  addVendorInvoiceData.attachment &&
    formData.append("attachment", addVendorInvoiceData.attachment);
  return await axios.post(`${api_base_url}/VendorInvoice`, formData);
};

export const editInvoice = async (invoiceNewData) => {
  const data = await axios.put(
    `${api_base_url}/VendorInvoice/UpdateInvoice`,
    invoiceNewData
  );
  return data;
};

export const getPdf = async (file) => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetPdf?fileName=${file}`,
    {
      responseType: "arraybuffer",
    }
  );
  return data;
};

export const openPdfNewTab = async (file) => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/OpenPdf?fileName=${file}`,
    {
      responseType: "arraybuffer",
    }
  );
  return data;
};

export const recalllInvoice = async (ids) => {
  const data = await axios.put(
    `${api_base_url}/VendorInvoice/RecallInvoice`,
    ids
  );
  return data;
};

export const denyInvoice = async (ids) => {
  const data = await axios.put(
    `${api_base_url}/VendorInvoice/DenyInvoice`,
    ids
  );
  return data;
};

export const approvedInvoice = async (ids) => {
  const data = await axios.put(`${api_base_url}/VendorInvoice/Approved`, ids);
  return data;
};

export const getInvoiceBy = async (searchDetails) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/searchInvoiceDetails`,
    searchDetails
  );
};
export const GetAllVendorInvoiceCounts = async () => {
  const data = await axios.get(`${api_base_url}/VendorInvoice/GetCount`);
  return data;
};

export const getUnverifiedInvoiceCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/UnverifiedInvoiceCount`
  );
  return data;
};

export const getForReviewInvoiceCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/ForReviewInvoiceCount`
  );
  return data;
};

export const getApprovedInvoiceCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/ApprovedInvoiceCount`
  );
  return data;
};

export const getCompletedInvoiceCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/CompletedInvoiceCount`
  );
  return data;
};

export const getVoidedInvoiceCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/VoidedInvoiceCount`
  );
  return data;
};

export const changePdf = async (invoiceData) => {
  const formData = new FormData();
  invoiceData.attachment &&
    formData.append("attachment", invoiceData.attachment);
  invoiceData.id && formData.append("invoiceDetailsId", invoiceData.id);
  return await axios.put(`${api_base_url}/VendorInvoice/ChangePdf`, formData);
};

export const voidedAddInvoice = async (addVendorInvoiceData) => {
  const formData = new FormData();
  addVendorInvoiceData.id &&
    formData.append("invoiceDetailsId", addVendorInvoiceData.id);
  return await axios.post(
    `${api_base_url}/VendorInvoice/VoidedAddInvoice`,
    formData
  );
};

export const getVoidedInvoices = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetAllVoidedInvoices`
  );
  return data;
};

export const submitToAcumatica = async (ids) => {
  const data = await axios.put(
    `${api_base_url}/VendorInvoice/SubmitToAcumatica`,
    ids
  );
  return data;
};

export const getActivityHistoryById = async (id) => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetActivityHistoryById/${id}`
  );
  return data.data;
};

export const getApprovedInvoiceToday = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetApprovedInvoiceToday`
  );
  return data;
};

export const getVendorInvoiceCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/AllVendorInvoiceCount`
  );
  return data;
};

export const getExpenseAccount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/ExpenseAccount`
  );
  return data;
};

export const getItemizedDetailsById = async (invoiceDetailsId: number) => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/ItemizedDetails/${invoiceDetailsId}`
  );
  return data;
};

export const getItemizedDetailsHistoryById = async (
  invoiceHistoryId: number
) => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/ItemizedDetailsHistory/${invoiceHistoryId}`
  );
  return data;
};

export const getInvoiceAutoPay = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/InvoiceAutoPay`
  );
  return data;
};

export const editInvoiceReconcilliation = async (invoiceNewData) => {
  const data = await axios.put(
    `${api_base_url}/VendorInvoice/UpdateInvoiceReconcilliation`,
    invoiceNewData
  );
  return data;
};

export const getVendorDetailsById = async (invoiceDetailsId: number) => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/InvoiceById/${invoiceDetailsId}`
  );
  return data;
};

export const getReconciliationCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/ReconciliationCount`
  );
  return data;
};

export const addDebitAdjustment = async (addDebitAdjustment) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/DebitAdjustment`,
    addDebitAdjustment
  );
};

export const getOpenDebitAdjustments = async () => {
  const { data } = await axios.get(
    `${api_base_url}/VendorInvoice/GetDebitAdjustments`
  );
  return data;
};

export const getCompletedInvoices = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetCompletedInvoices`
  );
  return data;
};

export const getCompletedInvoiceById = async (id) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/GetCompletedInvoiceById`,
    id
  );
};

export const getSubmittedInvoices = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetSubmittedInvoices`
  );
  return data;
};

export const getSubmittedInvoiceById = async (id) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/GetSubmittedInvoiceById`,
    id
  );
};

export const getForReviewInvoices = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetForReviewInvoices`
  );
  return data;
};

export const getForReviewInvoiceById = async (id) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/GetForReviewInvoiceById`,
    id
  );
};

export const getPendingInvoices = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetPendingInvoices`
  );
  return data;
};

export const getPendingInvoiceById = async (id) => {
  return await axios.post(
    `${api_base_url}/VendorInvoice/GetPendingInvoiceById`,
    id
  );
};

export const getPendingReconciliationInvoices = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetPendingReconciliationInvoices`
  );
  return data;
};

export const getInvoiceDebitAdjustment = async () => {
  const data = await axios.get(
    `${api_base_url}/VendorInvoice/GetInvoiceDebitAdjustment`
  );
  return data;
};
